import React from 'react';
import SidebarParametres from '../../../layout/SidebarParametres';
import { useOAD } from '../../../layout/OADLayout';
import { CULTURES, getSemisPourCulture, RCP_OPTIONS } from '../../shared/constants';
import AleasTab from '../../shared/components/AleasTab';

/**
 * Comprendre / Fréquence des aléas.
 *
 * Contenu réel : AleasTab.jsx (déjà migré de DiagoEau, API `aleas` déjà
 * réelle) — pas de nouvelle route, pas de nouveau mock, juste le câblage de
 * la sidebar (culture + semis + scénario climatique) qui manquait encore.
 */
export default function ComprendreFrequenceAleas() {
  const { idExploit } = useOAD();
  const [culture, setCulture] = React.useState(CULTURES[0].id);
  const semisDisponibles = getSemisPourCulture(culture);
  const [semis, setSemis] = React.useState(semisDisponibles[0]?.value);
  const [rcp, setRcp] = React.useState(RCP_OPTIONS[0].value);

  React.useEffect(() => {
    if (!semisDisponibles.some((s) => s.value === semis)) {
      setSemis(semisDisponibles[0]?.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [culture]);

  const baseParams = React.useMemo(
    () => ({ idExploitation: idExploit, idProduction: culture, semis, rcp }),
    [idExploit, culture, semis, rcp]
  );

  return (
    <div className="oad-contenu">
      <SidebarParametres
        niveau1="comparer-comprendre"
        niveau2="comprendre"
        niveau3="frequence-aleas"
        idExploit={idExploit}
      >
        <label className="sidebar-champ">
          <span className="sidebar-label">Culture</span>
          <select value={culture} onChange={(e) => setCulture(Number(e.target.value))}>
            {CULTURES.map((c) => (
              <option key={c.id} value={c.id}>{c.label}</option>
            ))}
          </select>
        </label>

        <label className="sidebar-champ">
          <span className="sidebar-label">Date de semis</span>
          <select value={semis ?? ''} onChange={(e) => setSemis(e.target.value)}>
            {semisDisponibles.map((s) => (
              <option key={s.value} value={s.value}>{s.label}</option>
            ))}
          </select>
        </label>

        <fieldset className="sidebar-champ sidebar-groupe">
          <legend className="sidebar-label">Scénarios climatiques</legend>
          {RCP_OPTIONS.map((option) => (
            <label key={option.value} className="sidebar-radio">
              <input
                type="radio"
                name="scenario-clim-comprendre-aleas"
                value={option.value}
                checked={rcp === option.value}
                onChange={(e) => setRcp(e.target.value)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </fieldset>
      </SidebarParametres>

      <main className="oad-cards">
        <AleasTab baseParams={baseParams} />
      </main>
    </div>
  );
}
